import Storage from '../../utils/Storage';

export default (state = { }, action) => {
    switch (action.type) {
        case 'ui/nutritionView': {
            Storage.set('nutritionView', action.view);
            return {
                ...state,
                nutritionView: action.view
            }
        }
        default:
            return state;
    }
};
